import { IconName } from '@travelata-libs/ui-kit';
import { type TabType } from './types';
const DEFAULT_LEAD_TITLE = 'Не знаете куда поехать?';
const DEFAULT_LEAD_SUBTITLE = 'Эксперт поможет подобрать тур под ваш бюджет и даты';

type Tab = {
  text: string;
  type: TabType;
  icon: IconName;
  title: string;
  leadTitle: string;
  leadSubtitle: string;
  modalTitle?: string;
  searchBtnText?: string;
  dateFieldLabel?: string;
};

const tabs: Tab[] = [
  {
    text: 'Туры',
    type: 'tours',
    icon: IconName.Beach,
    title: 'Выбирайте путешествие сами',
    leadTitle: DEFAULT_LEAD_TITLE,
    leadSubtitle: DEFAULT_LEAD_SUBTITLE,
  },
  {
    text: 'Горящие',
    type: 'tours-hot',
    icon: IconName.Fire,
    title: 'Ловите туры со скидкой до 50%',
    leadTitle: DEFAULT_LEAD_TITLE,
    leadSubtitle: DEFAULT_LEAD_SUBTITLE,
  },
  {
    text: 'Отели',
    type: 'hotels',
    icon: IconName.Hotel,
    title: 'Выбирайте отель сами',
    leadTitle: 'Не знаете какой отель выбрать?',
    leadSubtitle: 'Эксперт поможет подобрать отель под ваш бюджет и даты',
    modalTitle: 'Подберём отель вместе',
    searchBtnText: 'Найти отели',
    dateFieldLabel: 'Дата заезда',
  },
  {
    text: 'Ж/Д',
    type: 'railway',
    icon: IconName.Train,
    title: 'Спланируйте поездку по России сами',
    leadTitle: DEFAULT_LEAD_TITLE,
    leadSubtitle: DEFAULT_LEAD_SUBTITLE,
    dateFieldLabel: 'Дата тура',
  },
];

export default tabs;
